module.exports = __webpack_public_path__ + "img/8X5.982cbacc.png";